import React, {useEffect, useRef, useState} from 'react';
import Modal from '@material-ui/core/Modal';
import Paper from "@material-ui/core/Paper";
import {
  Button,
  FormControl,
  InputBase,
  FormHelperText,
  makeStyles,
  MenuItem,
  Select,
  TextareaAutosize,
  withStyles, Typography, Box
} from '@material-ui/core';
import Styles from "./PowerDialerModal.module.css";
import {getPowerDialerLists, getPowerDialerVirtualNumbers, startCallFromOutside} from "./assets/ApiList";
import CloseIcon from "@material-ui/icons/Close";

const CustomInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
        color: 'black !important',
        fontSize: '20px!important'
      },
    },
    input: {
      fontSize: '14px !important',
      height: 'auto !important',
      color: '#707070 !important',
      borderRadius: '4px !important',
      position: 'relative',
      border: '1px solid #ced4da!important',
      padding: '10px 12px !important',
      marginBottom: '0!important',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        color: '#707070 !important',
        boxShadow: 'none!important',
        borderColor: 'black !important',
      },
    },
  }))(InputBase);


  const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      fontSize: '14px !important',
      borderRadius: '4px !important',
      position: 'relative',
      color: '#707070 !important',
      border: '1px solid #ced4da !important',
      padding: '10px 26px 10px 12px !important',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 4
      },
    },
  }))(InputBase);

  const useStyles = makeStyles((theme) => {
    return {
      root: {
        "&.MuiButton-root": {
          backgroundColor: '#008945',
          padding: '10px 20px',
          borderRadius: '4px'
        },
        "&.MuiButton-text": {
          color: "grey"
        },
        "&.MuiButton-contained": {
          color: "white"
        },
        "&.MuiButton-outlined": {
          color: "brown"
        }
      }
    };
  });

const PowerDialerModal = ({data, isOpen, onClose}) => {
  const listNameRef = useRef(null);
  const [powerDialerVirtualNumbers, setPowerDialerVirtualNumbers] = useState([]);
  const [powerDialerSettings, setPowerDialerSettings] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    virtual_number_id: '',
    copy_settings_id: '',
    color: "#546376"
  });
  const [submitting, setSubmitting] = useState(false);
  const [formErrorMessage, setFormErrorMessage] = useState({
    name: '',
    description: '',
    virtual_number_id: '',
    copy_settings_id: ''
  });

  const classes = useStyles();

  useEffect(()=>{
    getVirtualNumbers()
    getPowerDialerList()
    if(data?.type == "single-tag"){
      if(data?.name){
        handleFormDataChange("name", data?.name)
      }
    }
    else if(data?.type == "single-list"){
      if(data?.name){
        handleFormDataChange("name", data?.name)
      }
    }
    else if(data?.type == "deal-stage"){
      if(data?.name){
        handleFormDataChange("name", data?.name)
      }
    }
  },[]);

  const getVirtualNumbers = async  () => {
    try{
      const response = await getPowerDialerVirtualNumbers();
      if (response.success){
          const list = response.data.data;
          setPowerDialerVirtualNumbers(list);
        }else {
          setPowerDialerVirtualNumbers([]);
        }
    }catch (err){
      setPowerDialerVirtualNumbers([]);
    }
  }
  const getPowerDialerList = async  () => {
    try{
      const response = await getPowerDialerLists();
      if (response.success){
        const list = response.data.data;
        setPowerDialerSettings(list);
      }else {
        setPowerDialerSettings([]);
      }
    }catch (err){
      setPowerDialerSettings([]);
    }
  }

  const validateForm = () => {
    let cold = 1;
    const errorState = {
      name: '',
      virtual_number_id: ''
    };
    if (formData.name.length <= 0){
      errorState.name = 'List name is required!';
      if (listNameRef){
        listNameRef.current.focus();
      }
      cold = 0;
    }

    if (!formData.virtual_number_id){
      errorState.virtual_number_id = 'Virtual number is required!';
      cold = 0;
    }

    if (cold === 0){
      setFormErrorMessage({ ...formErrorMessage, ...errorState });
    }

    return cold;
  }
  const handleFormDataChange = (name, value) => {
      setFormData({ ...formData, [name]: value });
      if (formErrorMessage[name]){
        setFormErrorMessage({ ...formErrorMessage, [name]: '' });
      }
  }

  const renderPwdVnOptions = () => {
    const item = [];
    for(let i = 0; i < powerDialerVirtualNumbers.length; i++){
      item.push(<MenuItem className="dropdownhelper-menuitem-class" value={powerDialerVirtualNumbers[i].id}>{powerDialerVirtualNumbers[i].virtual_number}</MenuItem>);
    }
    return item;
  }
  const renderPwdSettingOptions = () => {
    const item = [];
    for(let i = 0; i < powerDialerSettings.length; i++){
      item.push(<MenuItem className="dropdownhelper-menuitem-class" value={powerDialerSettings[i].id}>{powerDialerSettings[i].title}</MenuItem>);
    }
    return item;
  }

  const renderErrorMessage = (fieldName) => {
    return <FormHelperText error>{formErrorMessage[fieldName]}</FormHelperText>;
  }

  const handleSubmit = async () => {
    if (validateForm()){
      setSubmitting(true)
      switch (data.type){
        case "single-tag":
          await tagListSingleSubmit();
          break;
        case "contact-list":
          await contactListSubmit();
          break;
        case "single-list":
          await myListSingleSubmit();
          break;
        case "deal-stage":
          await dealStageSubmit();
          break;
        default:
          return;
      }
    }
  };
  const tagListSingleSubmit = async () => {
    try{
      if (data.type){
        formData.source = data.type;
      }
      if (data.value){
        formData.value = data.value;
      }
      const response = await startCallFromOutside(formData);
      if (response.success){
        if(data.callback){
          data.callback(response, formData);
        }
        onClose();
      }
      setSubmitting(false)
    }catch (err){
      setSubmitting(false)
    }
  }
  const mapListSubmit = () => {}

  const contactListSubmit = async () => {
    try{
      if (data.type){
        formData.source = data.type;
      }
      if (data.contactIds){
        formData.contactIds = data.contactIds;
      }

      if (data.filter){
        formData.filter = data.filter;
      }

      const response = await startCallFromOutside(formData);
      if (response.success){
        if(data.callback){
          data.callback(response, formData);
        }
        onClose();
      }
      setSubmitting(false)
    }catch (err){
      setSubmitting(false)
    }
  }
  const myListSingleSubmit = async () => {
    try{
      if (data.type){
        formData.source = data.type;
      }
      if (data.value){
        formData.value = data.value;
      }
      const response = await startCallFromOutside(formData);
      if (response.success){
        if(data.callback){
          data.callback(response, formData);
        }
        onClose();
      }
      setSubmitting(false)
    }catch (err){
      setSubmitting(false)
    }
  }

  const dealStageSubmit = async () => {
    try{
      if (data.type){
        formData.source = data.type;
      }
      if (data.value){
        formData.value = data.value;
      }

      if (data.stageStatus){
        formData.stageStatus = data.stageStatus;
      }

      if (data.startDate){
        formData.startDate = data.startDate;

        if (data.endDate){
          formData.endDate = data.endDate;
        }
      }

      if (data.search){
        formData.search = data.search;
      }

      const response = await startCallFromOutside(formData);
      if (response.success){
        if(data.callback){
          data.callback(response, formData);
        }
        onClose();
      }
      setSubmitting(false)
    }catch (err){
      setSubmitting(false)
    }
  }

  const handleClose = () => {
    if(submitting){
      return;
    }
    if(data.callback){
      data.callback({success:false}, formData);
    }
    onClose();
  }

  return (
        <Modal
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={`${Styles.modalWrapper} global-xs-modal add_list_modal`}
        >
            <Paper className={Styles.modalInner}>
              <div className={Styles.headerWrapper}>
                <Typography variant="h5">Create New Power Dialer List</Typography>
                <Box className={Styles.headerClose} onClick={handleClose}>
                  <CloseIcon />
                </Box>
              </div>

              <div className={Styles.paddingWrp}>
                  <div className={Styles.modalBody}>
                    <FormControl className={Styles.formControl}>
                      <span className={Styles.label}>
                        List Name
                        <span className={Styles.required}> *</span>
                      </span>
                      <CustomInput
                          inputRef={listNameRef}
                          placeholder='List name here'
                          id="list-name"
                          name="name"
                          value={formData.name}
                          onChange={(e)=>{handleFormDataChange('name', e.target.value)}}
                      />
                      {renderErrorMessage('name')}
                    </FormControl>

                    <FormControl className={Styles.formControl}>
                      <span className={Styles.label}>
                        Which number to call from?
                        <span className={Styles.required}> *</span>
                      </span>

                      <Select
                        labelId="vn-select-label"
                        id="vn-select"
                        name="virtual_number_id"
                        value={formData.virtual_number_id}
                        displayEmpty
                        onChange={(e)=>{ handleFormDataChange('virtual_number_id', e.target.value) }}
                        input={<BootstrapInput/>}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                      >
                        <MenuItem className="dropdownhelper-menuitem-class" value={''} disabled>Select a virtual number</MenuItem>
                        {renderPwdVnOptions()}
                      </Select>
                      {renderErrorMessage('virtual_number_id')}
                    </FormControl>

                    <FormControl className={Styles.formControl}>
                      <span className={Styles.label}>
                        Description
                      </span>
                      <TextareaAutosize
                          className={Styles.textArea}
                          aria-label="Description"
                          minRows={4}
                          placeholder="Write here..."
                          name="description"
                          value={formData.description}
                          onChange={(e)=>{handleFormDataChange('description', e.target.value)}}
                      />
                      {renderErrorMessage('description')}
                    </FormControl>

                    <FormControl className={Styles.formControl}>
                      <span className={Styles.label}>
                        Copy Settings from
                      </span>

                      <Select
                        labelId="setting-select-label"
                        id="setting-select"
                        name="copy_settings_id"
                        value={formData.copy_settings_id}
                        displayEmpty
                        onChange={(e)=>{handleFormDataChange('copy_settings_id', e.target.value)}}
                        input={<BootstrapInput />}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                      >
                        <MenuItem className="dropdownhelper-menuitem-class" value={''}>None</MenuItem>
                        {renderPwdSettingOptions()}
                      </Select>
                      {renderErrorMessage('copy_settings_id')}
                    </FormControl>
                  </div>

                  <div className={Styles.modalFooter}>
                    <Button style={{padding: '10px 20px', }} onClick={handleClose} size="large">Cancel</Button>
                    <Button disabled={submitting} size="large" onClick={handleSubmit} className={classes.root} variant="contained">
                      {submitting ? 'Saving....' : 'Save'}
                    </Button>
                  </div>
                </div>
            </Paper>
        </Modal>
    );
}

export default PowerDialerModal;

/*
{
    name: 'Default list name',
    callback:() => {},
    type:"map-list",
    tagId: ""
}
* */
